<template>
  <span class="count-badge" v-bind:class="'bg-' + color">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['color']
}
</script>

<style scoped>
  .count-badge {
    border: 1px solid lightgrey;
    border-radius: 100%;
    padding: 0 6px;
    font-size: 14px;
    box-sizing: border-box;
  }
</style>